module.exports = __webpack_public_path__ + "img/newImage2.82103697.svg";